import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component"
import "react-vertical-timeline-component/style.min.css"
import { Work, WorkHistory } from "@mui/icons-material";
import "../styles/Experience.css"
import { useLanguage } from "../helpers/LanguageContext";
import { translations } from "../helpers/translations";

function Experience() {
    const { language } = useLanguage();
    const t = translations[language].experience;

    return (
        <div className="experience">
            <VerticalTimeline lineColor="#ffffff">
                <VerticalTimelineElement className="vertical-timeline-element--work"
                    date={language === 'en' ? "2025 November - " : "Novembre 2025 - "}
                    dateClassName="date"
                    iconStyle={{ background: "#080B10", color: "#fff" }}
                    icon={<Work />}>
                    <span className="mobile-date">{language === 'en' ? "2025 November - " : "Novembre 2025 - "}</span>
                    <h4 className="vertical-timeline-element-title">{t.aiku.title}</h4>
                    <p className="paragraph" dangerouslySetInnerHTML={{ __html: t.aiku.description }}></p>
                </VerticalTimelineElement>
                <VerticalTimelineElement className="vertical-timeline-element--work"
                    date={language === 'en' ? "2025 January - 2025 October" : "Gennaio 2025 - Ottobre 2025"}
                    dateClassName="date"
                    iconStyle={{ background: "#080B10", color: "#fff" }}
                    icon={<Work />}>
                    <span className="mobile-date">{language === 'en' ? "2025 January - 2025 October" : "Gennaio 2025 - Ottobre 2025"}</span>
                    <h4 className="vertical-timeline-element-title">{t.berenice.title}</h4>
                    <p className="paragraph" dangerouslySetInnerHTML={{ __html: t.berenice.description }}></p>
                </VerticalTimelineElement>
                <VerticalTimelineElement className="vertical-timeline-element--work"
                    date={language === 'en' ? "2024 July - 2024 November" : "Luglio 2024 - Novembre 2024"}
                    dateClassName="date"
                    iconStyle={{ background: "#080B10", color: "#fff" }}
                    icon={<Work />}>
                    <span className="mobile-date">{language === 'en' ? "2024 July - 2024 November" : "Luglio 2024 - Novembre 2024"}</span>
                    <h4 className="vertical-timeline-element-title">{t.iquii.title}</h4>
                    <p className="paragraph" dangerouslySetInnerHTML={{ __html: t.iquii.description }}></p>
                </VerticalTimelineElement>
                <VerticalTimelineElement className="vertical-timeline-element--work"
                    date={language === 'en' ? "2023 March - 2024 July" : "Marzo 2023 - Luglio 2024"}
                    dateClassName="date"
                    iconStyle={{ background: "#080B10", color: "#fff" }}
                    icon={<Work />}>
                    <span className="mobile-date">{language === 'en' ? "2023 March - 2024 July" : "Marzo 2023 - Luglio 2024"}</span>
                    <h4 className="vertical-timeline-element-title">{t.fastweb.title}</h4>
                    <p className="paragraph" dangerouslySetInnerHTML={{ __html: t.fastweb.description }}></p>
                </VerticalTimelineElement>
                <VerticalTimelineElement className="vertical-timeline-element--work"
                    date={language === 'en' ? "2023 March - 2023 July" : "Marzo 2023 - Luglio 2023"}
                    dateClassName="date"
                    iconStyle={{ background: "#080B10", color: "#fff" }}
                    icon={<Work />}>
                    <span className="mobile-date">{language === 'en' ? "2023 March - 2023 July" : "Marzo 2023 - Luglio 2023"}</span>
                    <h4 className="vertical-timeline-element-title">{t.odda1.title}</h4>
                    <p className="paragraph" dangerouslySetInnerHTML={{ __html: t.odda1.description }}></p>
                </VerticalTimelineElement>
                <VerticalTimelineElement className="vertical-timeline-element--work"
                    date={language === 'en' ? "2022 November - 2023 February" : "Novembre 2022 - Febbraio 2023"}
                    dateClassName="date"
                    iconStyle={{ background: "#080B10", color: "#fff" }}
                    icon={<Work />}>
                    <span className="mobile-date">{language === 'en' ? "2022 November - 2023 February" : "Novembre 2022 - Febbraio 2023"}</span>
                    <h4 className="vertical-timeline-element-title">{t.odda2.title}</h4>
                    <p className="paragraph" dangerouslySetInnerHTML={{ __html: t.odda2.description }}></p>
                </VerticalTimelineElement>
                <VerticalTimelineElement className="vertical-timeline-element--work"
                    date={language === 'en' ? "2022 September - 2022 November" : "Settembre 2022 - Novembre 2022"}
                    dateClassName="date"
                    iconStyle={{ background: "#080B10", color: "#fff" }}
                    icon={<WorkHistory />}>
                    <span className="mobile-date">{language === 'en' ? "2022 September - 2022 November" : "Settembre 2022 - Novembre 2022"}</span>
                    <h4 className="vertical-timeline-element-title">{t.odda3.title}</h4>
                    <p className="paragraph" dangerouslySetInnerHTML={{ __html: t.odda3.description }}></p>
                </VerticalTimelineElement>
                <VerticalTimelineElement className="vertical-timeline-element--work"
                    date={language === 'en' ? "2021 November - 2022 August" : "Novembre 2021 - Agosto 2022"}
                    dateClassName="date"
                    iconStyle={{ background: "#080B10", color: "#fff" }}
                    icon={<Work />}>
                    <span className="mobile-date">{language === 'en' ? "2021 November - 2022 August" : "Novembre 2021 - Agosto 2022"}</span>
                    <h4 className="vertical-timeline-element-title">{t.microdata.title}</h4>
                    <p className="paragraph" dangerouslySetInnerHTML={{ __html: t.microdata.description }}></p>
                </VerticalTimelineElement>
                <VerticalTimelineElement className="vertical-timeline-element--work"
                    date={language === 'en' ? "2021 March - 2021 September" : "Marzo 2021 - Settembre 2021"}
                    dateClassName="date"
                    iconStyle={{ background: "#080B10", color: "#fff" }}
                    icon={<Work />}>
                    <span className="mobile-date">{language === 'en' ? "2021 March - 2021 September" : "Marzo 2021 - Settembre 2021"}</span>
                    <h4 className="vertical-timeline-element-title">{t.idara.title}</h4>
                    <p className="paragraph" dangerouslySetInnerHTML={{ __html: t.idara.description }}></p>
                </VerticalTimelineElement>
                <VerticalTimelineElement className="vertical-timeline-element--work"
                    date={language === 'en' ? "2020 September - 2021 October" : "Settembre 2020 - Ottobre 2021"}
                    dateClassName="date"
                    iconStyle={{ background: "#080B10", color: "#fff" }}
                    icon={<Work />}>
                    <span className="mobile-date">{language === 'en' ? "2020 September - 2021 October" : "Settembre 2020 - Ottobre 2021"}</span>
                    <h4 className="vertical-timeline-element-title">{t.cgs.title}</h4>
                    <p className="paragraph" dangerouslySetInnerHTML={{ __html: t.cgs.description }}></p>
                </VerticalTimelineElement>
            </VerticalTimeline>
        </div >
    )
}

export default Experience